import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(3)
  }
}))
